import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE } from "@/lib/content";
import { CountUp, MaskLines, Reveal } from "@/components/site/Motion";

export function Disclaimer({ className = "", dark = false }: { className?: string; dark?: boolean }) {
  return <p data-testid="results-disclaimer" className={`text-xs font-medium italic ${dark ? "text-cream/75" : "text-charcoal-soft"} ${className}`}>{SITE.disclaimer}</p>;
}

export function FounderStory({ showLink = true }: { showLink?: boolean }) {
  return (
    <section data-testid="founder-story" className="grain relative overflow-hidden bg-forest py-24 text-cream sm:py-32">
      <div className="wrap relative grid items-center gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-6">
          <div className="relative mx-auto max-w-[560px]">
            <div className="absolute -inset-3 rounded-[34px] border border-gold/40" />
            <img src="/images/sony-before-after.jpg" alt={`${SITE.founder} before and after his ${SITE.founderKg} kg weight loss`} loading="lazy" className="relative w-full rounded-[28px] object-cover shadow-[0_40px_80px_-30px_rgba(0,0,0,0.7)]" data-testid="founder-before-after-image" />
          </div>
        </Reveal>
        <div className="lg:col-span-6">
          <p className="eyebrow-dark">Proof, starting with the founder</p>
          <p className="mt-6 flex items-end gap-3 font-display leading-[0.8] text-cream" data-testid="founder-kg">
            <CountUp to={SITE.founderKg} className="text-[7rem] sm:text-[10rem]" testId="founder-kg-count" />
            <span className="pb-4 text-4xl italic text-gold-soft sm:text-5xl">kg</span>
          </p>
          <h2 className="mt-6 max-w-xl text-4xl leading-tight sm:text-5xl">
            <MaskLines lines={["Sony didn't learn this", <em key="t" className="text-gold-soft">from a textbook.</em>]} />
          </h2>
          <Reveal>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/85 sm:text-lg">
              {SITE.founder} lost {SITE.founderKg} kg on his own journey, through the same everyday habits he now coaches. He's a wellness coach, not a dietitian, and he'll always tell you which is which.
            </p>
            <Disclaimer dark className="mt-4" />
            {showLink && <Link to="/about" data-testid="founder-about-link" className="btn-cream mt-8">Read Sony's story <ArrowRight className="h-4 w-4" /></Link>}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
